import { DailyCapitalization, IndexHistory, IndexHistoryCap } from 'hooks/type-of-use-indices'

import Big from 'big.js'
import { CapitalizationOfProps } from 'utils/product-service'
import { PortfolioReturns } from '../storage/interface'
import { assertMultiply } from 'utils'

export const getPortfolioValues = (userData: IndexHistory[], indicesCollection: string[]) => {
  const values: { y: string; investmentCap: string }[] = []
  const userFormattedData: IndexHistoryCap[] = userData.map((el) => {
    assertMultiply(el.balance, el.product.basePrice)
    return {
      ...el,
      date: Number(el.timestamp),
      marketCap: Big(el.balance).mul(el.product.basePrice).toString(),
      tokenHeld: Big(el.balance).precision(5).toString(),
    }
  })

  const arr: (DailyCapitalization | IndexHistoryCap)[] = [...userFormattedData].sort((a, b) => {
    if (a.date < b.date) return -1
    if (a.date > b.date) return 1
    return 0
  })

  const lastCapitalizationOf: CapitalizationOfProps = indicesCollection.reduce((a, v) => {
    const key = v.includes('-') ? v.split('-')[0] : v
    return { ...a, [key]: { cap: Big(0) } }
  }, {})

  let totalCapitalization = Big(0)
  let investedCap = Big(0)
  const investedCapArray: { [key: string]: Big } = {
    CAI: Big(0),
    JMX: Big(0),
    ARTXAI: Big(0),
  }

  for (let i = 0; i < arr.length; i++) {
    const accountBalance = arr[i] as IndexHistoryCap
    const isIndex = accountBalance.investedCapital
    const capItem = isIndex ? accountBalance.investedCapital : accountBalance.capitalization
    investedCapArray[accountBalance.product.symbol] = Big(capItem)

    if (lastCapitalizationOf[accountBalance.product.id]) {
      if (Big(totalCapitalization).gt(0)) {
        totalCapitalization = Big(totalCapitalization).sub(
          lastCapitalizationOf[accountBalance.product.id].cap,
        )
      }
      totalCapitalization = Big(totalCapitalization).add(Big(accountBalance.marketCap))
      investedCap = Object.values(investedCapArray).reduce((a, b) => {
        return Big(a).add(b)
      })
      lastCapitalizationOf[accountBalance.product.id].cap = Big(accountBalance.marketCap)
    }
    values.push({
      y: totalCapitalization.precision(5).toString(),
      investmentCap: investedCap.precision(5).toString(),
    })
  }

  return {
    basePrice: values[values.length - 1].y,
    investmentCap: values[values.length - 1].investmentCap,
  }
}

export const getProcessedValue = (portfolioValues: PortfolioReturns) => {
  if (portfolioValues.investedCapital && portfolioValues.investmentValue) {
    const { investedCapital, investmentValue } = portfolioValues

    if (investedCapital.gt(0) && investmentValue.gt(0)) {
      assertMultiply(investmentValue.div(investedCapital).minus(1), 100)
      return investmentValue.div(investedCapital).minus(1).mul(100).precision(2)
    }
  }
  return Big(0)
}
